import React from 'react';
import { useParams, useHistory, useLocation, Switch, Route, Router, Link} from 'react-router-dom';
import Header from './component/Header/header';
import Museum from './component/Museum/museum';
import Exhibition from './component/Exhibition/exhibition';
import Event from './component/Event/event';
import Admin from './component/Admin/admin-top-page'
import Footer from './component/Footer/footer'
import PrivatePage from './component/Admin/admin-center-page'
import PrivateRoute from './component/Admin/private_router'
import PublicPage from './component/Admin/login-page'
import PublicRoute from './component/Admin/public_router';
import Top_page from './component/top-page';

function App() {
  return (
    <div className="App">
      <Header/>
      <Switch className='main'>
        <Route path='/museums'><Museum/></Route>
        <Route path='/exhibitions'><Exhibition/></Route>
        <Route path='/events'><Event/></Route>
        <Route exact path='/'><Top_page/></Route>
        <PublicRoute path="/admin/login" component={PublicPage} />
        <PrivateRoute path="/admin/private" component={PrivatePage} />   
      </Switch>
    <Footer/>
    </div>
  
  );
}

export default App;
